module.exports = __webpack_public_path__ + "static/img/0.3f536ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dww/0.png
// module id = qWO9
// module chunks = 0